// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry, type ModalsMap } from 'components/Mantine/Modals/createModalRegistry';
import { WorkOrderTravelerModal } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderTravelerModal';
import { BlockWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/CancellationAndBlocking/BlockWorkOrderModal';
import { CancelWorkOrderRequestedModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/CancellationAndBlocking/CancelWorkOrderRequestedModal';
import { CancelWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/CancelWorkOrderModal';
import { DeleteWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/DeleteWorkOrderModal';
import { RejectWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/RejectWorkOrderModal';
import { TransferWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/TransferWorkOrderModal';
import { WorkOrderActionBlockedModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderActionBlockedModal';
import { WorkOrderRejectedModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderRejectedModal';
import { WorkOrderTransferredModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderTransferredModal';
import { NeedsNeedByModal } from 'modules/Shop/WorkOrders/WorkOrdersPage/NeedsNeedByModal';

const workOrderModals = {
  blockWorkOrderModal: BlockWorkOrderModal,
  cancelWorkOrderModal: CancelWorkOrderModal,
  cancelWorkOrderRequestedModal: CancelWorkOrderRequestedModal,
  deleteWorkOrderModal: DeleteWorkOrderModal,
  needsNeedByModal: NeedsNeedByModal,
  rejectWorkOrderModal: RejectWorkOrderModal,
  transferWorkOrderModal: TransferWorkOrderModal,
  workOrderActionBlockedModal: WorkOrderActionBlockedModal,
  workOrderRejectedModal: WorkOrderRejectedModal,
  workOrderTransferredModal: WorkOrderTransferredModal,
  workOrderTravelerModal: WorkOrderTravelerModal,
} as const satisfies ModalsMap;

export type WorkOrderModals = typeof workOrderModals;

/**
 * The Work Order modals opened from the shared action surfaces (grid row menu, detail page actions, mobile
 * actions) and by `WorkOrdersProvider` itself, which mounts this registry app-wide.
 */
export const [WorkOrderModalProvider, useWorkOrderModals, useWorkOrderTrackedModal] =
  createModalRegistry(workOrderModals);
